<template>
  <cms-stats
    v-if="statsSetUp"
    :theme="statOptions"
    :content="statsContentByVersion"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewStats' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);
const statsContent = computed(() => mainStore.statsContent);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const statOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('stats'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const statsSetUp = computed(() => {
  if (statOptions.value.version === 'S4') {
    return isThemePreview.value
      ? statsContent.value[statOptions.value.version].nested_content
      : !isEmpty(homepage.value?.stats?.[id.value]?.nested_content);
  }
  return !isEmpty(homepage.value?.stats?.[id.value]?.content);
});

const statsContentByVersion = computed(() =>
  isThemePreview.value ? statsContent.value[statOptions.value.version] : homepage.value.stats[id.value],
);
</script>

<style></style>
